import { AuthService } from './../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { Client } from './../../../models/client';
import { Bus } from './../../../models/bus';
import { BusAlertConf } from './../../../models/bus-alert-conf';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { RequestOptions } from '@angular/http';
import { Select2OptionData, Select2TemplateFunction } from 'ng2-select2';
import { PNotifyService } from '../../../services/pnotify.service';

@Component({
  selector: 'app-bus-view',
  templateUrl: './bus-view.component.html',
  styleUrls: ['./bus-view.component.css']
})
export class BusViewComponent implements OnInit {

  bus: Bus;
  clients: any[];
  schools: any[];
  alerts: any[];
  assistants: any[];
  selectedAlerts: {};
  oldBusAlertConfs: any[];
  isAdmin: boolean;
  alertDesc: any[];
  pnotify = undefined;
  typeAlerteZone: Array<Select2OptionData>;
  iconeNameListe: Array<Select2OptionData>;

  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private roleService: NgxRolesService,
    pnotifyService: PNotifyService
  ) {
    this.bus = new Bus();
    this.alerts = [];
    this.selectedAlerts = {};
    this.oldBusAlertConfs = [];
    this.alertDesc = [];
    this.isAdmin = (this.roleService.getRole('ROLE_ADMIN')) ? true : false;
    this.typeAlerteZone = [
      { id: '1', text: 'Entrée' },
      { id: '2', text: 'Sortie' },
      { id: '3', text: 'Entrée/Sortie' }
    ];
    this.iconeNameListe = [
      { id: 'Ambulance', text: 'Ambulance' },
      { id: 'Bus', text: 'Bus scolaire' },
      { id: 'Camion', text: 'Camion' },
      { id: 'Colis', text: 'Colis' },
      { id: 'Fourgonnette', text: 'Fourgonnette' },
      { id: 'Moto', text: 'Moto' },
      { id: 'Ruche', text: 'Ruche' },
      { id: 'Taxi', text: 'Taxi' },
      { id: 'Voiture', text: 'Voiture' },
      { id: 'Velo-Taxi', text: 'Velo-Taxi' }
    ];
    this.route.params.subscribe(params => {
      this.http.get(
        '/api/bus/' + params['id']
      ).subscribe((bus: Bus) => {
        if (
          (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT'))
          && this.authService.getUser().id !== bus.clientId
        ) {
          this.router.navigate(['']);
        }
        this.bus = bus;
        this.updateSelectedAlerts();
        this.initClientSelect();
        this.initSchoolSelect();
        this.initAssistantSelect();
      });
    });
    this.initAlertSelect();
    this.pnotify = pnotifyService.getPNotify();
  }

  ngOnInit() {
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_ADMIN')) {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
      });
    }
  }

  initSchoolSelect() {
    let params = new HttpParams({
      fromObject: {
        clientId: this.bus.clientId + ''
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
    });
  }
  initAssistantSelect() {
    const params = new HttpParams({
      fromObject: {
        clientId: this.bus.clientId + '',
        isAssistant: 'true'
      }
    });
    this.http.get(
      '/api/passenger/lookup',
      { params }
    ).subscribe((assistants: any) => {
      this.assistants = assistants.rows;
    });
  }


  initAlertSelect() {
    let params = new HttpParams({
      fromObject: {
        isAdmin: this.isAdmin + '',
      }
    });
    this.http.get(
      '/api/alert/lookup',
      { params }
    ).subscribe((alerts: any[]) => {
      this.alerts = alerts;
      this.updateSelectedAlerts();
    });
  }

  updateSelectedAlerts() {
    for (let i = 0; i < this.alerts.length; i++) {
      this.selectedAlerts[this.alerts[i].id] = {
        isAdmin: this.alerts[i].isAdmin,
        isDate: this.alerts[i].isDate,
        index: null
      };
    }
    for (let i = 0; i < this.bus.BusAlertConfs.length; i++) {
      if (this.bus.BusAlertConfs[i].alertId != null) {
        if (typeof this.alerts[this.bus.BusAlertConfs[i].alertId - 1] !== 'undefined') {
          this.alertDesc[i] = this.alerts[this.bus.BusAlertConfs[i].alertId - 1].description;
        }
        if (this.selectedAlerts.hasOwnProperty(this.bus.BusAlertConfs[i].alertId)) {
          this.selectedAlerts[this.bus.BusAlertConfs[i].alertId].index = i;
        } else if (this.bus.BusAlertConfs[i].hasOwnProperty('Alert') &&
          this.bus.BusAlertConfs[i].Alert.id == this.bus.BusAlertConfs[i].alertId) {
          this.selectedAlerts[this.bus.BusAlertConfs[i].alertId] = {
            isAdmin: this.bus.BusAlertConfs[i].Alert.isAdmin,
            isDate: this.bus.BusAlertConfs[i].Alert.isAdmin,
            index: i
          };
        } else {
          this.selectedAlerts[this.bus.BusAlertConfs[i].alertId] = {
            isAdmin: true,
            isDate: false,
            index: i
          };
        }
      }
    }
  }

  changeAlert(index) {
    const isDate = this.selectedAlerts[this.bus.BusAlertConfs[index].alertId].isDate;
    Object.keys(this.selectedAlerts).forEach((alertId) => {
      if (this.selectedAlerts[alertId].index == index &&
        this.selectedAlerts[alertId].isDate != isDate) {
        this.bus.BusAlertConfs[index].value = '';
        return false;
      }
    });
    this.oldBusAlertConfs = this.bus.BusAlertConfs;
    this.updateSelectedAlerts();
  }

  addAlert() {
    this.bus.BusAlertConfs.push(new BusAlertConf());
    this.oldBusAlertConfs = this.bus.BusAlertConfs;
    this.updateSelectedAlerts();
  }

  removeAlert(index) {
    let tmpBusAlertConfs = [];
    while (index < this.bus.BusAlertConfs.length - 1) {
      tmpBusAlertConfs.unshift(this.bus.BusAlertConfs.pop());
    }
    if (index == this.bus.BusAlertConfs.length - 1) {
      this.bus.BusAlertConfs.pop();
    }
    setTimeout(() => {
      while (tmpBusAlertConfs.length) {
        this.bus.BusAlertConfs.push(tmpBusAlertConfs.shift());
      }
      this.oldBusAlertConfs = this.bus.BusAlertConfs;
      this.updateSelectedAlerts();
    }, 10);
  }

  typeAlerteZoneChanged(e: any) {
    //this.journey.type = e.value;
    //this.refreshMap();
  }

  onSubmit(): void {
    this.http.put(
      '/api/bus/' + this.bus.id,
      { bus: this.bus }
    ).subscribe(
      (bus: Bus) => {
        this.bus = bus;
        this.router.navigate(['/bus/view', this.bus.id]);
      },
      (error) => {
        this.pnotify.error({
          title: 'Erreur',
          text: 'Une erreur est survenue !',
          stack: {
            firstpos1: 70, firstpos2: 10,
            modal: true,
            overlay_close: true
          },
          hide: false,
          modules: {
            Confirm: {
              confirm: true,
              buttons: [
                {
                  text: 'Ok',
                  addClass: 'btn btn-chico',
                  click: notice => {
                    notice.close();
                  }
                }
              ]
            }
          }
        });
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/bus/bus-view/bus-view.component.ts